import { render, staticRenderFns } from "./preTodayTotalPoint.vue?vue&type=template&id=bc4baef8&"
import script from "./preTodayTotalPoint.vue?vue&type=script&lang=js&"
export * from "./preTodayTotalPoint.vue?vue&type=script&lang=js&"
import style0 from "./preTodayTotalPoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports